// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"278da5ca","538":"22bcbdbe","544":"13f0f408"}[chunkId] + ".chunk.js";
};